module.exports = __webpack_public_path__ + "img/back.33a982c7.svg";